import { createErrorReporter as errorReporterFactory } from '@lib/errorReporter'

const DEFAULT_ERROR_REPORTER = 'console';

const createErrorReporter = () => (
  errorReporterFactory(process.env.ERROR_REPORTER_DRIVER || DEFAULT_ERROR_REPORTER)
);

export default createErrorReporter;
